import React from 'react';
import { motion } from 'framer-motion';
import { WHATSAPP_LINKS } from '../../config/whatsapp';

const Trainings = () => {
  const trainingsList = [
    "NR-05 - CIPA",
    "NR-06 - EPI",
    "NR-10 - Segurança em Instalações Elétricas",
    "NR-11 - Operação de Empilhadeiras",
    "NR-12 - Segurança em Máquinas e Equipamentos",
    "NR-13 - Caldeiras e Vasos de Pressão",
    "NR-17 - Ergonomia",
    "NR-18 - Condições e Meio Ambiente na Indústria da Construção",
    "NR-20 - Líquidos Combustíveis e Inflamáveis",
    "NR-23 - Proteção Contra Incêndios",
    "NR-33 - Espaços Confinados",
    "NR-35 - Trabalho em Altura"
  ];

  return (
    <section id='treinamentos' className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-teal-700 mb-4">Treinamentos</h2>
          <p className="text-gray-700 max-w-3xl mx-auto">
            Oferecemos treinamentos especializados para atender às normas regulamentadoras 
            e necessidades específicas da sua empresa. Nossa equipe de instrutores é 
            altamente qualificada e certificada.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          {trainingsList.map((training, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              viewport={{ once: true }}
              className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
            >
              <div className="flex items-center">
                <div className="w-8 h-8 bg-teal-100 text-teal-700 rounded-full flex items-center justify-center mr-3">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-gray-700">{training}</span>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="text-center">
          <a 
            href={WHATSAPP_LINKS.focoseg}
            target="_blank"
            rel="noopener noreferrer" 
            className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-6 rounded-md transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
              <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
            </svg>
            Solicitar Treinamento
          </a>
        </div>
      </div>
    </section>
  );
};

export default Trainings;